import React, {useState, useEffect} from 'react';

import {useSelector, useDispatch} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {Get} from '@/api/request';
import CalibrationHistoryIcon from '@/assets/icons/calibration-history.svg';
import * as APPDATA from '@/constants/pcConstAppData';
import UseIsDemoMode from '@/hooks/useIsDemoMode';
import {consoleLog} from '@/libs/consoleHelper';
import {newLineHtml} from '@/libs/htmlHelper';

import TareButton from './TareButton';

import '../CalibrationLoadCellSensor.less';

function CheckScales() {
  const dispatch = useDispatch();
  const isPCRunning = useSelector((state) => state.setupStore.isPCRunning);
  const fontSize = useSelector((state) => state.setupStore.fontSize);

  const [proteinSensor, setProteinSensor] = useState(0);
  const [bufferSensor, setBufferSensor] = useState(0);
  const isDemoMode = UseIsDemoMode();
  // const [ProteinTubeDetected, setProteinTubeDetected] = useState("false");
  // const [BufferTubeDetected, setBufferTubeDetected] = useState("false");
  const [classTubeDetectedAlert, setClassTubeDetectedAlert] = useState('tube-detected-warning not-visibile-div ');
  const [disabledTare, setDisabledTare] = useState(false);

  let intervalGetSensor;
  let intervalGetTubeDetect;
  // let cekStatusTare;
  let ProteinTubeDetected = false;
  let BufferTubeDetected = false;

  useEffect(() => {
    dispatch(setupActions.updateActiveMenu(APPDATA.CALIBRATION_LOAD_CELL_CHECK_SCALE));
    let disableSecondarButton = false;
    if (isPCRunning) {
      disableSecondarButton = true;
    }
    setupTopMenuProperties(false, disableSecondarButton);
    intervalGetSensor = setInterval(() => {
      Get(APPDATA.API.GET_ALL_SENSOR_VALUE, '', successGetSensorValue);
    }, 300);
    Get(APPDATA.API.IS_TUBE_SENSOR_AVAILABLE, '', successGetTubeSensorAvailable);
    // return a function to execute at unmount
    return () => {
      dispatch(setupActions.topButtonSecondaryProperties(undefined));
      if (typeof intervalGetTubeDetect !== 'undefined') clearInterval(intervalGetTubeDetect);
      if (typeof intervalGetSensor !== 'undefined') clearInterval(intervalGetSensor);
    };
  }, []); // notice the empty array

  useEffect(() => {
    if (classTubeDetectedAlert === 'tube-detected-warning not-visibile-div ') {
      setDisabledTare(false);
    } else {
      setDisabledTare(true);
    }
  }, [classTubeDetectedAlert]);

  const setupTopMenuProperties = (showSecondaryButton, disableSecondarButton) => {
    // eslint-disable-next-line no-param-reassign
    disableSecondarButton = disableSecondarButton === undefined ? false : disableSecondarButton;
    const topButtonProperties = {
      id: APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE,
      label: APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE,
      onClick: onClickCalibrateScale,
      disabled: isDemoMode,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: backToWelcome,
    };
    const titleMenuProperties = APPDATA.CALIBRATION_LOAD_CELL_CHECK_SCALE;
    const calibrationHistoryButton = showSecondaryButton
      ? {
          id: 'CalibrationHistory',
          onClick: onClickCalibrationHistory,
          className: 'calibrationHistoryButton',
          icon: CalibrationHistoryIcon,
          disabled: disableSecondarButton,
        }
      : undefined;
    setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties, calibrationHistoryButton);
  };
  // TODO : refactor using hook
  const setTopMenuProperties = (
    topButtonProperties,
    backButtonProperties,
    titleMenuProperties,
    calibrationHistoryButton,
  ) => {
    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
        topButtonSecondaryButtonProperties: calibrationHistoryButton,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };
  // TODO : refactor using hook
  const backToWelcome = () => {
    window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_ADDRESS;
  };
  const successGetSensorValue = (response) => {
    setProteinSensor(response.data.VolumeSensor.sensor0);
    setBufferSensor(response.data.VolumeSensor.sensor2);
    // setProteinSensor(Math.random() * (200 - 0) + 0)
    // setBufferSensor(Math.random() * (200 - 0) + 0)
  };
  const successGetTubeSensorAvailable = (response) => {
    if (response.data) {
      consoleLog('Tube Sensor Available');
      intervalGetTubeDetect = setInterval(() => {
        checkIsTubeAttach();
      }, 500);
    } else {
      consoleLog('Tube Sensor Not Available');
    }
  };
  const onClickCalibrateScale = () => {
    window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CALIBRATE_SCALE_ADDRESS;
  };
  const onClickCalibrationHistory = () => {
    window.location.href = APPDATA.CALIBRRATION_HISTORY_ADRESS;
  };

  // const successGetTareIsDone = (response, passingVariabel) => {
  //   let TareDone = 0;
  //   consoleLog('successGetTareIsDone', response);
  //   if (response.data[APPDATA.KEY.ProteinTube].IsDone === true) TareDone += 1;
  //   if (response.data[APPDATA.KEY.BufferTube].IsDone === true) TareDone += 1;
  //   if (passingVariabel !== 0 && TareDone === passingVariabel) {
  //     dispatch(loadingActions.updateLoading({showLoading: false}));
  //     dispatch(
  //       setupActions.showAlert({
  //         alertShow: true,
  //         alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.TARE_SUCCESS_TEXT,
  //         alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
  //       }),
  //     );
  //     consoleLog('TARE Done');
  //     if (typeof cekStatusTare !== 'undefined') clearInterval(cekStatusTare);
  //   }
  //   consoleLog('count of tare done', TareDone);
  // };

  const checkIsTubeAttach = async () => {
    await Get(APPDATA.API.IS_BOTTLE_PROTEIN_ATTACHED, '', successGetTubeAttach, APPDATA.KEY.ProteinTube);
    await Get(APPDATA.API.IS_BOTTLE_BUFFER_ATTACHED, '', successGetTubeAttach, APPDATA.KEY.BufferTube);
    // consoleLog("checkIsTubeAttach", {ProteinTubeDetected, BufferTubeDetected});
    // if (ProteinTubeDetected === "true" || BufferTubeDetected === "true") {
    // 	setClassTubeDetectedAlert("tube-detected-warning ");
    // } else {
    // 	setClassTubeDetectedAlert("tube-detected-warning not-visibile-div ");
    // }
  };
  // const successGetProteinTubeAttach = (response, passingVariabel) => {
  // 	if (response.data) {
  // 		setProteinTubeDetected("true");
  // 		consoleLog("successGetProteinTubeAttach ", ProteinTubeDetected);
  // 	} else {
  // 		setProteinTubeDetected("false");
  // 	}
  // 	consoleLog("Protein Tube Detect ", response.data);
  // };
  const successGetTubeAttach = (response, passingParam) => {
    // if (response.data) {
    // 	setBufferTubeDetected("true");
    // 	consoleLog("successGetBufferTubeAttach ", BufferTubeDetected);
    // } else {
    // 	setBufferTubeDetected("false");
    // }
    // consoleLog("Buffer Tube Detect ", response.data);
    consoleLog(`${passingParam} Tube Detect ${response.data}`);
    if (response.data) {
      switch (passingParam) {
        case APPDATA.KEY.ProteinTube:
          // setProteinTubeDetected(true);
          ProteinTubeDetected = true;
          break;
        case APPDATA.KEY.BufferTube:
          // setBufferTubeDetected(true);
          BufferTubeDetected = true;
          break;
        default:
          break;
      }
    } else {
      switch (passingParam) {
        case APPDATA.KEY.ProteinTube:
          // setProteinTubeDetected(false);
          ProteinTubeDetected = false;
          break;
        case APPDATA.KEY.BufferTube:
          // setBufferTubeDetected(false);
          BufferTubeDetected = false;
          break;
        default:
          break;
      }
    }
    if (ProteinTubeDetected === true || BufferTubeDetected === true) {
      setClassTubeDetectedAlert('tube-detected-warning ');
    } else {
      setClassTubeDetectedAlert('tube-detected-warning not-visibile-div ');
    }
  };

  const style = {
    constraint: {
      fontSize: fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : fontSize,
    },
  };

  return (
    <div
      className="calibration-wizzard"
      style={style.constraint}
    >
      <div className="row-title">{newLineHtml(APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CHECK_SCALES)}</div>
      <div className="div-2col50">
        <div className="div-1col">
          <div className="row-scale-sensor">
            <b>{APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SAMPLE_SCALE}</b>
          </div>
          <div className="div-3colInput row-scale-sensor">
            <div style={{textAlign: 'right'}}>{APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT}</div>
            <div style={{paddingLeft: 40, paddingRight: 40}}>
              {parseFloat(proteinSensor).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)}
            </div>
            <div>{APPDATA.FIELD_NAME.MEASURES}</div>
          </div>
        </div>
        <div className="div-1col">
          <div className="row-scale-sensor">
            <b>{APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.BUFFER_SCALE}</b>
          </div>
          <div className="div-3colInput row-scale-sensor">
            <div style={{textAlign: 'right'}}>{APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT}</div>
            <div style={{paddingLeft: 40, paddingRight: 40}}>
              {parseFloat(bufferSensor).toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)}
            </div>
            <div>{APPDATA.FIELD_NAME.MEASURES}</div>
          </div>
        </div>
      </div>
      <div className={classTubeDetectedAlert}>
        <div className="icon">
          <span className="glyphicon glyphicon-alert " />
        </div>
        <div className="tube-detected-warning-text">{APPDATA.MESSAGES.IS_TUBE_ATTACHED.TUBE_DETECTED}</div>
      </div>
      <div
        className="row-scale-sensor-button div-1col"
        style={{paddingTop: '15px'}}
      >
        <TareButton disabledTare={disabledTare}>{APPDATA.FIELD_NAME.TARE.toUpperCase()}</TareButton>
      </div>
    </div>
  );
}
export default CheckScales;
